module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAVUlEQVR4AWMYHCDLQf//JQETkjHChCLN/0BDKDMAaggFBiAMIdcABG7cOfU/EQDVAHRcvW0C+QbU7ZhMgQusREESxGEYIFMzwgAyNSMMgGomHQ8PAADBPjI4TaWK3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SD.png
// module id = 1258
// module chunks = 0